import { Lock, Clock, CalendarClock, Globe2 } from "lucide-react";
import { StatusBadge } from "@/components/StatusBadge";
import { fmtDateTime, durationLabel } from "@/lib/time";
import { SyncIcon } from "@/components/SyncIcon";

const Tile = ({ icon: Icon, label, value, hint, testId }) => (
  <div className="min-w-0">
    <p className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground"><Icon className="h-4 w-4" /> {label}</p>
    <p data-testid={testId} className="mt-1 break-words text-lg font-semibold leading-snug">{value}</p>
    {hint && <p className="mt-0.5 text-sm text-muted-foreground">{hint}</p>}
  </div>
);

export const Take5Header = ({ doc, durationOverride, plannedEndOverride, actions }) => {
  const site = doc.site;
  const duration = durationOverride !== undefined ? durationOverride : doc.duration_minutes;
  const end = plannedEndOverride !== undefined ? plannedEndOverride : doc.planned_end_at;
  return (
    <div className="rise rounded-xl border border-border bg-card">
      <div className="hazard-stripe h-1.5 rounded-t-xl" />
      <div className="p-4 sm:p-6">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="font-data text-xs uppercase tracking-[0.2em] text-amber-400">Take 5 {doc.revision > 1 ? `· Révision ${doc.revision}` : ""}</p>
            <h1 data-testid="take5-title" className="mt-1 break-words font-heading text-3xl font-extrabold uppercase tracking-tight sm:text-4xl">{doc.task || "Nouvelle tâche"}</h1>
            <p className="text-sm text-muted-foreground">{doc.site.name} · {doc.user_name}</p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <StatusBadge status={doc.status} size="lg" testId="take5-status-badge" />
            <SyncIcon id={doc.id} size="h-5 w-5" testId="take5-sync-icon" />
            {doc.superseded_by && <StatusBadge status="superseded" size="lg" testId="take5-superseded-badge" />}
            {actions}
          </div>
        </div>
        <div className="mt-5 grid gap-4 rounded-lg border border-border bg-background/50 p-4 sm:grid-cols-3">
          <Tile icon={Lock} label="Début (automatique)" value={fmtDateTime(doc.start_at, site)} testId="take5-start-at" hint={doc.offline ? `Heure de l'appareil (hors ligne)${doc.synced_at ? ` · reçu par le serveur ${fmtDateTime(doc.synced_at, site)}` : " · en attente d'envoi"}` : "Horodaté par le serveur, non modifiable"} />
          <Tile icon={Clock} label="Durée prévue" value={durationLabel(duration)} testId="take5-duration-display" />
          <Tile icon={CalendarClock} label="Fin prévue (calculée)" value={end ? fmtDateTime(end, site) : "Choisissez une durée"} testId="take5-planned-end" hint="Début + durée prévue" />
        </div>
        <p className="mt-2 flex items-center gap-1 text-xs text-muted-foreground"><Globe2 className="h-3.5 w-3.5" /> Heures du site : {site.timezone} · format {site.time_format === "12h" ? "12 h" : "24 h"}</p>
      </div>
    </div>
  );
};
